export const new_GroupButton = "Ddc";
export const delete_GroupButton = "Edc";
export const moveAndDelete_GroupButton = "Fdc";
export const neverBlockGroupOrDL_Button = "Gdc";
export const respond_GroupButton = "Hdc";
export const respond_GroupOverflow_Button = "Idc";
export const tags_GroupButton = "Jdc";
export const tags_GroupOverflow_Button = "Kdc";
export const send_GroupButton = "Ldc";
export const send_GroupOverflow_Button = "Mdc";
export const sync_GroupButton = "Ndc";
export const sync_GroupOverflow_Button = "Odc";
export const offline_GroupButton = "Pdc";
export const offline_GroupOverflow_Button = "Qdc";
export const download_GroupButton = "Rdc";
export const download_GroupOverflow_Button = "Sdc";
export const quickSteps_GroupButton = "Tdc";
export const move_GroupButton = "Udc";
export const archivePolicy_menuGroupLabel = "Vdc";
export const retentionPolicy_menuGroupLabel = "Wdc";
export const find_GroupButton = "Xdc";
export const speech_GroupButton = "Ydc";
export const addIns_GroupButton = "Zdc";
export const teams_GroupButton = "_dc";
export const insights_GroupButton = "$dc";
export const protection_GroupButton = "aec";
export const immersiveReader_GroupButton = "bec";
export const print_GroupButton = "cec";
export const undo_GroupButton = "dec";
export const toggleLeftPane_Group = "eec";
export const clipboard_Group = "fec";
export const names_Group = "gec";
export const include_Group = "hec";
export const voice_Group = "iec";
export const encrypt_Group = "jec";
export const save_Group = "kec";
export const sensitivity_Group = "lec";
export const basicText_Group = "mec";
export const paragraph_Group = "nec";
export const tables_Group = "oec";
export const links_Group = "pec";
export const illustrations_Group = "qec";
export const notes_GroupNew = "rec";
export const notes_GroupEdit = "sec";
export const notes_GroupView = "tec";
export const table_GroupMerge = "uec";
export const table_GroupInsert = "vec";
export const table_GroupStructure = "wec";
export const table_GroupAlignment = "xec";
export const table_GroupTableStyles = "yec";
export const viewSettings_Group = "zec";
export const viewMessages_Group = "Aec";
export const viewLayout_Group = "Bec";
export const playMyEmails_Group = "Cec";
export const tools_Group = "Dec";
export const tags_Group = "Eec";
export const actions_Group = "Fec";
export const findTime_GroupButton = "Gec";
export const insert_Group = "Hec";
export const options_Group = "Iec";
export default {new_GroupButton,delete_GroupButton,moveAndDelete_GroupButton,neverBlockGroupOrDL_Button,respond_GroupButton,respond_GroupOverflow_Button,tags_GroupButton,tags_GroupOverflow_Button,send_GroupButton,send_GroupOverflow_Button,sync_GroupButton,sync_GroupOverflow_Button,offline_GroupButton,offline_GroupOverflow_Button,download_GroupButton,download_GroupOverflow_Button,quickSteps_GroupButton,move_GroupButton,archivePolicy_menuGroupLabel,retentionPolicy_menuGroupLabel,find_GroupButton,speech_GroupButton,addIns_GroupButton,teams_GroupButton,insights_GroupButton,protection_GroupButton,immersiveReader_GroupButton,print_GroupButton,undo_GroupButton,toggleLeftPane_Group,clipboard_Group,names_Group,include_Group,voice_Group,encrypt_Group,save_Group,sensitivity_Group,basicText_Group,paragraph_Group,tables_Group,links_Group,illustrations_Group,notes_GroupNew,notes_GroupEdit,notes_GroupView,table_GroupMerge,table_GroupInsert,table_GroupStructure,table_GroupAlignment,table_GroupTableStyles,viewSettings_Group,viewMessages_Group,viewLayout_Group,playMyEmails_Group,tools_Group,tags_Group,actions_Group,findTime_GroupButton,insert_Group,options_Group};